import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginLayout from '@/views/LoginLayout'
import Page404Layout from '@/views/Page404Layout'
import AdminRouterOutlet from '@/views/main/admin/AdminRouterOutlet'
import TerminalLayout from '@/views/TerminalLayout'
import { getStorageJson } from '@/utils/storage'

Vue.use(VueRouter)

const terminalRoutes = [
  {
    path: '/home',
    redirect: '/home/index',
    meta: {
      title: '地面站',
      hidden: true,
      workspace: 'ground-station'
    }
  },
  {
    path: '/home/index',
    component: () => import('@/views/main/ground-station/OverviewPage'),
    meta: {
      title: '地面站概况',
      icon: 'iconfont icon-fuwudiqiu',
      tapName: 'plane',
      workspace: 'ground-station'
    }
  },
  {
    path: '/settings/index',
    component: () => import('@/views/main/admin/settings/SettingsPage'),
    meta: {
      title: '设置',
      icon: 'iconfont icon-shezhi',
      tapName: 'plane',
      hidden: true,
      workspace: 'settings'
    }
  },
  {
    path: '/help/index',
    component: () => import('@/views/main/admin/settings/HelpPage'),
    meta: {
      title: '帮助',
      icon: 'el-icon-question',
      tapName: 'plane',
      hidden: true,
      workspace: 'settings'
    }
  },
  {
    path: '/model',
    component: AdminRouterOutlet,
    redirect: '/model/index',
    meta: {
      title: '机型',
      icon: 'iconfont icon-chuiqigudingyi',
      tapName: 'plane',
      adminNavigationGroup: 'aviation'
    },
    children: [
      {
        path: '/model/index',
        component: () => import('@/views/main/admin/aircraft/ModelListPage'),
        meta: {
          title: '机型管理',
          icon: 'iconfont icon-a-wurenji2',
          tapName: 'plane'
        }
      },
      {
        path: '/model/add',
        redirect: to => ({ path: '/model/index', query: { ...to.query, modelAction: 'create' }, hash: to.hash }),
        meta: {
          title: '添加机型',
          icon: 'el-icon-plus',
          tapName: 'plane',
          hidden: true
        }
      },
      {
        path: '/model/edit/:id',
        redirect: to => ({ path: '/model/index', query: { ...to.query, modelAction: 'edit', modelId: to.params.id }, hash: to.hash }),
        meta: {
          title: '编辑机型',
          icon: 'el-icon-edit',
          tapName: 'plane',
          hidden: true
        }
      }
    ]
  },
  {
    path: '/register',
    component: AdminRouterOutlet,
    redirect: '/register/index',
    meta: {
      title: '飞机',
      icon: 'el-icon-edit-outline',
      tapName: 'plane',
      adminNavigationGroup: 'aviation'
    },
    children: [
      {
        path: '/register/index',
        component: () => import('@/views/main/admin/aircraft/AircraftListPage'),
        meta: {
          title: '飞机管理',
          icon: 'iconfont icon-huan-wurenjifeihangjihua',
          tapName: 'plane'
        }
      },
      {
        path: '/register/add',
        redirect: to => ({ path: '/register/index', query: { ...to.query, aircraftAction: 'create' }, hash: to.hash }),
        meta: {
          title: '添加飞机',
          icon: 'el-icon-plus',
          tapName: 'plane',
          hidden: true
        }
      },
      {
        path: '/register/edit/:id',
        redirect: to => ({ path: '/register/index', query: { ...to.query, aircraftAction: 'edit', aircraftId: to.params.id }, hash: to.hash }),
        meta: {
          title: '编辑飞机',
          icon: 'el-icon-edit',
          tapName: 'plane',
          hidden: true
        }
      },
      {
        path: '/register/flyData',
        component: () => import('@/views/main/admin/aircraft/FlightDataPage'),
        meta: {
          title: '飞行数据统计',
          icon: 'el-icon-data-line',
          tapName: 'plane',
          hidden: true
        }
      },
      {
        path: '/register/flyLog',
        component: () => import('@/views/main/admin/aircraft/FlightLogPage'),
        meta: {
          title: '飞机历史日志',
          icon: 'el-icon-data-line',
          tapName: 'plane',
          hidden: true
        }
      }
    ]
  },
  {
    path: '/nofly',
    component: AdminRouterOutlet,
    redirect: '/nofly/setNofly',
    meta: {
      title: '飞行限制',
      icon: 'iconfont icon-jinfeiqu',
      tapName: 'plane',
      adminNavigationGroup: 'aviation'
    },
    children: [
      {
        path: '/nofly/setNofly',
        component: () => import('@/views/main/admin/aviation/NoFlyZonePage'),
        meta: {
          title: '禁飞区配置',
          icon: 'iconfont icon-huizhi',
          tapName: 'plane',
          fullHeightMap: true
        }
      },
      {
        path: '/nofly/setRestrictfly',
        component: () => import('@/views/main/admin/aviation/RestrictedFlightPage'),
        meta: {
          title: '限飞区配置',
          icon: 'iconfont icon-huizhi',
          tapName: 'plane',
          fullHeightMap: true
        }
      }
    ]
  },
  {
    path: '/route',
    component: AdminRouterOutlet,
    redirect: '/route/index',
    meta: {
      title: '航线',
      icon: 'iconfont icon-feihangluxian',
      tapName: 'plane',
      adminNavigationGroup: 'aviation'
    },
    children: [
      {
        path: '/route/index',
        component: () => import('@/views/main/admin/aviation/RouteListPage'),
        meta: {
          title: '航线管理',
          icon: 'iconfont icon-feihangluxian',
          tapName: 'plane'
        }
      },
      {
        path: '/route/add',
        component: () => import('@/views/main/admin/aviation/RouteFormPage'),
        meta: {
          title: '航线设计',
          icon: 'iconfont icon-huizhi',
          tapName: 'plane',
          hidden: true,
          fullHeightMap: true
        }
      },
      {
        path: '/route/edit/:id',
        component: () => import('@/views/main/admin/aviation/RouteFormPage'),
        meta: {
          title: '编辑航线',
          icon: 'iconfont icon-huizhi',
          tapName: 'plane',
          hidden: true,
          fullHeightMap: true
        }
      }
    ]
  },
  {
    path: '/site',
    component: AdminRouterOutlet,
    redirect: '/site/index',
    meta: {
      title: '站点',
      icon: 'iconfont icon-zhandianguanli',
      tapName: 'plane',
      adminNavigationGroup: 'aviation'
    },
    children: [
      {
        path: '/site/index',
        component: () => import('@/views/main/admin/aviation/SiteListPage'),
        meta: {
          title: '站点管理',
          icon: 'iconfont icon-jingqu',
          tapName: 'plane'
        }
      },
      {
        path: '/site/add',
        redirect: to => ({ path: '/site/index', query: { ...to.query, siteAction: 'create' }, hash: to.hash }),
        meta: {
          title: '添加站点',
          icon: 'el-icon-plus',
          tapName: 'plane',
          hidden: true
        }
      },
      {
        path: '/site/edit/:id',
        redirect: to => ({ path: '/site/index', query: { ...to.query, siteAction: 'edit', siteId: to.params.id }, hash: to.hash }),
        meta: {
          title: '编辑站点',
          icon: 'el-icon-edit',
          tapName: 'plane',
          hidden: true
        }
      }
    ]
  },
  {
    path: '/mapstyle',
    component: AdminRouterOutlet,
    redirect: '/mapstyle/index',
    meta: {
      title: '地图样式',
      icon: 'el-icon-map-location',
      tapName: 'plane',
      adminNavigationGroup: 'aviation'
    },
    children: [
      {
        path: '/mapstyle/index',
        component: () => import('@/views/main/admin/aviation/MapStyleListPage'),
        meta: {
          title: '地图样式管理',
          icon: 'el-icon-map-location',
          tapName: 'plane'
        }
      },
      {
        path: '/mapstyle/add',
        redirect: { path: '/mapstyle/index', query: { action: 'create' } },
        meta: {
          title: '添加地图',
          icon: 'el-icon-plus',
          tapName: 'plane',
          hidden: true
        }
      },
      {
        path: '/mapstyle/edit/:id',
        redirect: to => ({ path: '/mapstyle/index', query: { action: 'edit', id: to.params.id } }),
        meta: {
          title: '编辑地图',
          icon: 'el-icon-edit',
          tapName: 'plane',
          hidden: true
        }
      }
    ]
  },
  {
    path: '/mini-program',
    component: AdminRouterOutlet,
    redirect: '/mini-program/config',
    meta: {
      title: '小程序维护',
      icon: 'iconfont icon-xiaochengxu',
      tapName: 'admin',
      adminNavigationGroup: 'system'
    },
    children: [
      {
        path: '/mini-program/config',
        component: () => import('@/views/main/admin/operations/MiniProgramConfigPage'),
        meta: {
          title: '小程序维护',
          icon: 'iconfont icon-xiaochengxu',
          tapName: 'admin',
          dataRefreshKeys: ['sysConfig']
        }
      }
    ]
  },
  {
    path: '/maintenance',
    component: AdminRouterOutlet,
    redirect: '/maintenance/index',
    meta: {
      title: '后端维护',
      icon: 'iconfont icon-jiekou',
      tapName: 'admin',
      adminNavigationGroup: 'system'
    },
    children: [
      {
        path: '/maintenance/index',
        component: () => import('@/views/main/admin/operations/MaintenancePage'),
        meta: {
          title: '后端维护',
          icon: 'iconfont icon-jiekou',
          tapName: 'admin'
        }
      }
    ]
  },
  {
    path: '/middleware-maintenance',
    component: AdminRouterOutlet,
    redirect: '/middleware-maintenance/index',
    meta: {
      title: '中间件维护',
      icon: 'iconfont icon-shezhi',
      tapName: 'admin',
      adminNavigationGroup: 'system'
    },
    children: [
      {
        path: '/middleware-maintenance/index',
        component: () => import('@/views/main/admin/operations/MiddlewareMaintenancePage'),
        meta: {
          title: '中间件维护',
          icon: 'iconfont icon-shezhi',
          tapName: 'admin'
        }
      }
    ]
  },
  {
    path: '/map-proxy-maintenance',
    component: AdminRouterOutlet,
    redirect: '/map-proxy-maintenance/index',
    meta: {
      title: '地图代理维护',
      icon: 'el-icon-map-location',
      tapName: 'admin',
      adminNavigationGroup: 'system'
    },
    children: [
      {
        path: '/map-proxy-maintenance/index',
        component: () => import('@/views/main/admin/operations/MapProxyMaintenancePage'),
        meta: {
          title: '地图代理维护',
          icon: 'el-icon-map-location',
          tapName: 'admin'
        }
      }
    ]
  },
  {
    path: '/shop',
    component: AdminRouterOutlet,
    redirect: '/shop/edit',
    meta: {
      title: '商铺',
      icon: 'iconfont icon-a-shanghu_choose2x1',
      tapName: 'admin',
      adminNavigationGroup: 'commerce'
    },
    children: [
      {
        path: '/shop/edit',
        component: () => import('@/views/main/admin/accounts/ShopFormPage'),
        meta: {
          title: '商铺管理',
          icon: 'iconfont icon-dianpuguanli',
          tapName: 'admin'
        }
      },
      {
        path: '/shop/add',
        component: () => import('@/views/main/admin/accounts/ShopFormPage'),
        meta: {
          title: '添加商铺',
          icon: 'iconfont icon-check',
          tapName: 'admin'
        }
      }
    ]
  },
  {
    path: '/visitor',
    component: AdminRouterOutlet,
    redirect: '/visitor/index',
    meta: {
      title: '游客',
      icon: 'el-icon-user',
      tapName: 'admin',
      adminNavigationGroup: 'access'
    },
    children: [
      {
        path: '/visitor/index',
        component: () => import('@/views/main/admin/accounts/VisitorListPage'),
        meta: {
          title: '游客管理',
          icon: 'el-icon-user',
          tapName: 'admin'
        }
      }
    ]
  },
  {
    path: '/admin',
    component: AdminRouterOutlet,
    redirect: '/admin/index',
    meta: {
      title: '账户',
      icon: 'iconfont icon-guanliyuan',
      tapName: 'admin',
      adminNavigationGroup: 'access'
    },
    children: [
      {
        path: '/admin/index',
        component: () => import('@/views/main/admin/accounts/AccountListPage'),
        meta: {
          title: '账户管理',
          icon: 'iconfont icon-yonghuguanli',
          tapName: 'admin'
        }
      },
      {
        path: '/admin/add',
        redirect: { path: '/admin/index', query: { action: 'create' } },
        meta: {
          title: '添加账户',
          icon: 'iconfont icon-xinzengguanliyuan',
          tapName: 'admin',
          hidden: true
        }
      },
      {
        path: '/admin/edit/:id',
        component: () => import('@/views/main/admin/accounts/AccountFormPage'),
        meta: {
          title: '编辑账户',
          icon: 'iconfont icon-huizhi',
          tapName: 'admin',
          hidden: true
        }
      }
    ]
  },
  {
    path: '/role',
    component: AdminRouterOutlet,
    redirect: '/role/index',
    meta: {
      title: '角色',
      icon: 'el-icon-key',
      tapName: 'admin',
      adminNavigationGroup: 'access'
    },
    children: [
      {
        path: '/role/index',
        component: () => import('@/views/main/admin/accounts/RoleListPage'),
        meta: {
          title: '角色权限',
          icon: 'el-icon-key',
          tapName: 'admin',
          dataRefreshKeys: ['admin']
        }
      },
      {
        path: '/role/add',
        redirect: to => ({ path: '/role/index', query: { ...to.query, action: 'create' } }),
        meta: {
          title: '新建角色',
          icon: 'el-icon-plus',
          tapName: 'admin',
          hidden: true
        }
      },
      {
        path: '/role/edit/:id',
        redirect: to => ({ path: '/role/index', query: { ...to.query, action: 'edit', id: to.params.id } }),
        meta: {
          title: '编辑角色',
          icon: 'el-icon-edit',
          tapName: 'admin',
          hidden: true
        }
      }
    ]
  },
  {
    path: '/message',
    component: AdminRouterOutlet,
    redirect: '/message/index',
    meta: {
      title: '公告',
      icon: 'el-icon-microphone',
      tapName: 'admin',
      adminNavigationGroup: 'content'
    },
    children: [
      {
        path: '/message/index',
        component: () => import('@/views/main/admin/messaging/MessageListPage'),
        meta: {
          title: '公告管理',
          icon: 'el-icon-chat-line-square',
          tapName: 'admin',
          dataRefreshKeys: ['message']
        }
      },
      {
        path: '/message/pub',
        redirect: { path: '/message/index', query: { action: 'create' } },
        meta: {
          title: '发布公告',
          icon: 'el-icon-microphone',
          tapName: 'admin',
          hidden: true
        }
      }
    ]
  },
  {
    path: '/category',
    component: AdminRouterOutlet,
    redirect: '/category/index',
    meta: {
      title: '分类',
      icon: 'iconfont icon-a-ziliaocaozuoxianshifenleishu',
      tapName: 'admin',
      adminNavigationGroup: 'commerce'
    },
    children: [
      {
        path: '/category/index',
        component: () => import('@/views/main/admin/products/CategoryPage'),
        meta: {
          title: '分类管理',
          icon: 'iconfont icon-a-ziliaocaozuoxianshifenleishu',
          tapName: 'admin'
        }
      }
    ]
  },
  {
    path: '/product',
    component: AdminRouterOutlet,
    redirect: '/spu/index',
    meta: {
      title: '商品',
      icon: 'iconfont icon-chanpin',
      tapName: 'admin',
      adminNavigationGroup: 'commerce'
    },
    children: [
      {
        path: '/spu/index',
        component: () => import('@/views/main/admin/products/SpuListPage'),
        meta: {
          title: 'SPU管理',
          icon: 'iconfont icon-spuliebiao',
          tapName: 'admin'
        }
      },
      {
        path: '/spu/add',
        redirect: to => ({ path: '/spu/index', query: { ...to.query, action: 'create' } }),
        meta: {
          title: '添加SPU',
          icon: 'iconfont icon-huoquchanpin',
          tapName: 'admin',
          hidden: true
        }
      },
      {
        path: '/spu/edit/:id',
        redirect: to => ({ path: '/spu/index', query: { ...to.query, action: 'edit', id: to.params.id } }),
        meta: {
          title: '编辑SPU',
          icon: 'iconfont icon-huoquchanpin',
          tapName: 'admin',
          hidden: true
        }
      },
      {
        path: '/sku/index',
        component: () => import('@/views/main/admin/products/SkuListPage'),
        meta: {
          title: 'SKU管理',
          icon: 'iconfont icon-sku',
          tapName: 'admin'
        }
      },
      {
        path: '/sku/add',
        redirect: to => ({ path: '/sku/index', query: { ...to.query, action: 'create' } }),
        meta: {
          title: '添加SKU',
          icon: 'iconfont icon-sku1',
          tapName: 'admin',
          hidden: true
        }
      },
      {
        path: '/sku/edit/:id',
        redirect: to => ({ path: '/sku/index', query: { ...to.query, action: 'edit', id: to.params.id } }),
        meta: {
          title: '编辑SKU',
          icon: 'iconfont icon-sku1',
          tapName: 'admin',
          hidden: true
        }
      }
    ]
  },
  {
    path: '/broadcast',
    component: AdminRouterOutlet,
    redirect: '/broadcast/banner',
    meta: {
      title: '广告',
      icon: 'iconfont icon-guanggao',
      tapName: 'admin',
      adminNavigationGroup: 'commerce'
    },
    children: [
      {
        path: '/broadcast/banner',
        component: () => import('@/views/main/admin/content/BannerPage'),
        meta: {
          title: '轮播图配置',
          icon: 'iconfont icon-banner',
          tapName: 'admin'
        }
      },
      {
        path: '/broadcast/notice',
        component: () => import('@/views/main/admin/content/NoticePage'),
        meta: {
          title: '滚动通知配置',
          icon: 'iconfont icon-m-gundongwenzi',
          tapName: 'admin'
        }
      }
    ]
  },
  {
    path: '/order',
    component: AdminRouterOutlet,
    redirect: () => {
      const user = getStorageJson('userInfo', {})
      const permissions = user.permissions || []
      if (user.is_god || permissions.includes('order.view')) return '/order/index'
      if (permissions.includes('order.statistics')) return '/order/stat'
      return '/order/archive'
    },
    meta: {
      title: '订单',
      icon: 'iconfont icon-dingdantongji',
      tapName: 'admin',
      adminNavigationGroup: 'commerce'
    },
    children: [
      {
        path: '/order/index',
        component: () => import('@/views/main/admin/orders/OrderListPage'),
        meta: {
          title: '订单查询',
          icon: 'iconfont icon-a-SalesOrderManagement',
          tapName: 'admin'
        }
      },
      {
        path: '/order/show/:id',
        component: () => import('@/views/main/admin/orders/OrderDetailPage'),
        meta: {
          title: '订单详情',
          icon: 'iconfont icon-a-SalesOrderManagement',
          tapName: 'admin',
          hidden: true,
          dataRefreshKeys: ['paidOrder']
        }
      },
      {
        path: '/order/stat',
        component: () => import('@/views/main/admin/orders/OrderStatisticsPage'),
        meta: {
          title: '销售统计',
          icon: 'iconfont icon-data-view',
          tapName: 'admin'
        }
      },
      {
        path: '/order/archive',
        component: () => import('@/views/main/admin/orders/OrderArchivePage'),
        meta: {
          title: '日终处理',
          icon: 'iconfont icon-jintian',
          tapName: 'admin',
          dataRefreshKeys: ['paidOrder']
        }
      }
    ]
  }
]

const routes = [
  {
    path: '/',
    component: TerminalLayout,
    redirect: '/home/index',
    meta: {
      title: '终端',
      hidden: true,
      terminalShell: true
    },
    children: terminalRoutes
  },
  {
    path: '/login',
    component: LoginLayout,
    meta: {
      title: '登录',
      hidden: true
    }
  },
  {
    path: '/404',
    component: Page404Layout,
    meta: {
      title: '404',
      hidden: true
    }
  },
  {
    path: '*',
    redirect: '/404',
    meta: {
      title: '主页',
      hidden: true
    }
  }
]

// 路由与稳定权限代码的唯一映射。中文标题改名不会影响权限。
const routeAccessMap = {
  '/visitor': { godOnly: true },
  '/visitor/index': { godOnly: true },
  '/mini-program': { godOnly: true },
  '/maintenance': { godOnly: true },
  '/maintenance/index': { godOnly: true },
  '/mini-program/config': { godOnly: true },
  '/middleware-maintenance': { godOnly: true },
  '/middleware-maintenance/index': { godOnly: true },
  '/map-proxy-maintenance': { godOnly: true },
  '/map-proxy-maintenance/index': { godOnly: true },
  '/mapstyle': { godOnly: true },
  '/mapstyle/index': { godOnly: true },
  '/mapstyle/add': { godOnly: true },
  '/mapstyle/edit/:id': { godOnly: true },
  '/home': { permission: 'terminal.dashboard' },
  '/home/index': { permission: 'terminal.dashboard' },
  '/settings/index': { businessOnly: true },
  '/help/index': { businessOnly: true },
  '/model': { godOnly: true },
  '/model/index': { godOnly: true },
  '/model/add': { godOnly: true },
  '/model/edit/:id': { godOnly: true },
  '/register': { permission: 'plane.air.view' },
  '/register/index': { permission: 'plane.air.view' },
  '/register/add': { permission: 'plane.air.add' },
  '/register/edit/:id': { permission: 'plane.air.edit' },
  '/register/flyData': { permission: 'plane.air.data.view' },
  '/register/flyLog': { permission: 'plane.air.log.view' },
  '/nofly': { godOnly: true },
  '/nofly/setNofly': { godOnly: true },
  '/nofly/setRestrictfly': { godOnly: true },
  '/route': { permission: 'plane.route.view' },
  '/route/index': { permission: 'plane.route.view' },
  '/route/add': { permission: 'plane.route.add' },
  '/route/edit/:id': { permission: 'plane.route.edit' },
  '/site': { permission: 'plane.site.view' },
  '/site/index': { permission: 'plane.site.view' },
  '/site/add': { permission: 'plane.site.add' },
  '/site/edit/:id': { permission: 'plane.site.edit' },
  '/shop': { permission: 'shop.view' },
  '/shop/edit': { permission: 'shop.view' },
  '/shop/add': { godOnly: true },
  '/admin': { ownerOnly: true },
  '/admin/index': { ownerOnly: true },
  '/admin/add': { ownerOnly: true },
  '/admin/edit/:id': { authenticatedOnly: true, selfOrOwner: true },
  '/role': { ownerOnly: true },
  '/role/index': { ownerOnly: true },
  '/role/add': { ownerOnly: true },
  '/role/edit/:id': { ownerOnly: true },
  '/message': { permission: 'message.view' },
  '/message/index': { permission: 'message.view' },
  '/message/pub': { permission: 'message.add' },
  '/category': { permission: 'product.category.view' },
  '/category/index': { permission: 'product.category.view' },
  '/product': { permissions: ['product.spu.view', 'product.sku.view'] },
  '/spu/index': { permission: 'product.spu.view' },
  '/spu/add': { permission: 'product.spu.add' },
  '/spu/edit/:id': { permission: 'product.spu.edit' },
  '/sku/index': { permission: 'product.sku.view' },
  '/sku/add': { permission: 'product.sku.add' },
  '/sku/edit/:id': { permission: 'product.sku.edit' },
  '/broadcast': { permission: 'broadcast.view' },
  '/broadcast/banner': { permission: 'broadcast.view' },
  '/broadcast/notice': { permission: 'broadcast.view' },
  '/order': { permissions: ['order.view', 'order.statistics', 'order.archive'] },
  '/order/index': { permission: 'order.view' },
  '/order/show/:id': { permission: 'order.view' },
  '/order/stat': { permission: 'order.statistics' },
  '/order/archive': { permission: 'order.archive' }
}

function applyRouteAccess (routeList) {
  routeList.forEach(route => {
    if (routeAccessMap[route.path]) Object.assign(route.meta, routeAccessMap[route.path])
    if (Array.isArray(route.children)) applyRouteAccess(route.children)
  })
}

applyRouteAccess(routes)

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
